import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from './Svg.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonSvg({ prefix }));
}
